import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Constants } from '@config/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { IOperatorFunctionAggregation, IOperatorFunctionAggregationFilter } from 'app/models';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class OperatorFunctionAggregationService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) {}

  getAggregations(filter: IOperatorFunctionAggregationFilter): Observable<IOperatorFunctionAggregation[]> {
    let url = `${this.constants.DATA_AGGREGATED_OPERATOR_FUNCTION_ENDPOINT}?type=${filter.type}`;
    if (filter.machineFunction) { url += `&machineFunction=${filter.machineFunction}`; }
    if (filter.machineId != null) { url += `&machineId=${filter.machineId}`; }
    return this.http
      .get<IOperatorFunctionAggregation[]>(url)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
  }
}
